import { CSSProperties } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

interface DatePickerComponentProps {
    label: string;
    value: Dayjs | null;
    onChange: (newValue: Dayjs | null) => void;
    styles?: CSSProperties;
}

export default function DatePickerComponent({ label, value, onChange, styles }: DatePickerComponentProps) {
    return (
        <LocalizationProvider 
            dateAdapter={AdapterDayjs}
            adapterLocale="pt-br">
            <DatePicker
                className='date-picker'
                label={label}
                value={value}
                onChange={onChange}
                format="DD/MM/YYYY"
                sx={styles}
            />
        </LocalizationProvider>
    );
}